$('.text-slider__carousel').slick({
                                      dots: false,
                                      infinite: true,
                                      speed: 800,
                                      slidesToShow: 4,
                                      adaptiveHeight: true,
                                      arrows: false,
                                      draggable: true,
                                      autoplay: true,
                                      autoplaySpeed: 4000,
                                      responsive: [{
                                          breakpoint: 1200, settings: {
                                              slidesToShow: 3
                                          }
                                      }, {
                                          breakpoint: 768, settings: {
                                              slidesToShow: 2
                                          }
                                      }]
                                  });
